export default __webpack_public_path__ + "static/media/featured-item-15.761d382e.png";